<template>
  <Component :is="tag" :class="indent">
    <slot />
  </Component>
</template>

<script setup>
defineProps({
  tag: {
    type: String,
    default: 'div',
  },
  indent: {
    type: [String, Array],
    default: 'container-default',
  },
})
</script>
